import { resources } from "@constants/hardcoded-strings";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { updateAxnAdminUserRequest } from "@requests/axnadmin-core/update-axn-admin-user";
import { handleResponse } from "@utils/promise-util";
import { Dispatch } from "redux";

export const updateAxnAdminUsersCredentialsRequest = (dispatch: Dispatch) => async (
    organizationUsers: Array<AxnAdminUser>,
    loginServiceIDPID: string
): Promise<{ usersNotUpdated: Array<AxnAdminUser>, userUpdated: Array<AxnAdminUser> }> => {
    const requests = organizationUsers.map(orgUser => {
        const updatedAxnAdminUser = {
            ...orgUser,
            axnAdminUserDetails: {
                ...orgUser.axnAdminUserDetails,
                identityProviderID: loginServiceIDPID
            }
        }

        return updateAxnAdminUserRequest(updatedAxnAdminUser);
    });

    let index = 0;
    const responses = await Promise.allSettled(requests);

    return responses.reduce((acc, response) => {
        const data = handleResponse(
            dispatch,
            response,
            resources.requests.updateOrganizationUsersCredentials.error.title,
            resources.requests.updateOrganizationUsersCredentials.error.message,
        );
        if (data?.transferObject) {
            acc.userUpdated.push(data.transferObject);
        } else {
            acc.usersNotUpdated.push(organizationUsers[index]);
        }

        index++;
        return acc;
    }, { usersNotUpdated: [] as Array<AxnAdminUser>, userUpdated: [] as Array<AxnAdminUser> });
}